import { render, staticRenderFns } from "./CargoCrudStatusWaitingCollect.vue?vue&type=template&id=66cc1ef9"
import script from "./CargoCrudStatusWaitingCollect.vue?vue&type=script&lang=js"
export * from "./CargoCrudStatusWaitingCollect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports